
export class Discount {
  static readonly TYPE_PERCENTAGE = 'percent';
  static readonly TYPE_AMOUNT = 'amount';

  public type = Discount.TYPE_PERCENTAGE;
  public supplierId = 0;
  public description: string = null;
  public percentage = 0.0;
  public amount = 0.0;
  public applied = 0.0;
  public castIt(total: number, value = 0.0) {
    if (this.type === Discount.TYPE_AMOUNT) {
      this.applied = this.toPercent(value, total);
      return this.applied;
    }

    if (this.type === Discount.TYPE_PERCENTAGE) {
      this.applied = this.toAmount(value, total);
      return this.applied;
    }
  }

  private toPercent(amount: number, total: number): number {
    return parseFloat(((amount / total) * 100).toFixed(2));
  }

  private toAmount(percent: number, total: number): number {
    return parseFloat(((percent * total) / 100).toFixed(2));
  }

}
